import Vue from 'vue'
import _ from 'lodash'

const clients = {
  namespaced: true,
  state: {
    isLoading: true,
    clients: []
  },
  // CRUD / RESTful actions
  mutations: {
    SET_CLIENTS(state, data) {
      state.clients = data
    },
    NEW_CLIENT(state, data) {
      state.clients.unshift(data)
    },
    UPD_CLIENT(state, data) {
      const index = state.clients.findIndex(t => t.id == data.id)
      data.options = typeof data.options === 'string' ? JSON.parse(data.options) : data.options
      if(index !== -1) {
        state.clients.splice(index, 1, data)
      }
    },
    DEL_CLIENT(state, data) {
      state.clients = state.clients.filter(client => client.id != data.id)
    }
  },
  actions: {
    async fetch({commit}) {
      const response = await Vue.prototype.$axios.get('clients')
      commit('SET_CLIENTS', response.data)
    },
    async createClient({commit}, client) {
      Vue.prototype.$axios.post('clients', client).then(res => {
        Vue.prototype.$toastr.s('Created new client.')
        commit('NEW_CLIENT', res.data)
      }).catch(err => {
        console.log(err)
        Vue.prototype.$toastr.e('Could note create client.')
      })
    },
    async updateClient({commit}, client) {
      const response = await Vue.prototype.$axios.put(`clients/${client.id}`, client)
      commit('UPD_CLIENT', response.data)
    },
    async removeClient({commit}, client) {
      const response = await Vue.prototype.$axios.delete('clients/' + client.id)
      commit('DEL_CLIENT', response.data)
    }
  },
  getters: {
    allClients: state => state.clients,
    alfakodosCount(state) {
      console.log(state.auth.profile.user.__meta__.alfakodos_count)
      return state.auth.profile.user.__meta__.alfakodos_count
    },
    clientOptions:(state) => (params) => {
      const client = _.find(state.clients, {id: params.id})
      const options = JSON.parse(client.options)
      const currentTT = _.find(options, {name: 'currentTT'})
      const currentAK = _.find(options, {name: 'currentAK'})

      if(currentTT && params.type === "TT") {
        return currentTT
      } else if (currentAK && params.type === "AK") {
        return currentAK
      } else {
        return options
      }
    },
  }
}

export default clients